import { createVuetify, type ThemeDefinition } from "vuetify"
import '@mdi/font/css/materialdesignicons.css'

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    primary: "#FA7E24",
    secondary: "#344054",
    tertiary: "#495057",
    accent: "#82B1FF",
    error: "#f55a4e",
    info: "#00d3ee",
    success: "#5cb860",
    warning: "#ffa21a",
    application: "#EFEFEF",
  },
  variables: {

  }
}

export default createVuetify({
  theme: {
    defaultTheme: 'lightTheme',
    themes: {
      lightTheme
    }
  },
  defaults: {
    VCard: {
      elevation: 3,
      VCardTitle: {
        class: "mb-5 mt-2"
      },
      VCardActions: {
        VBtn: {
          color: "primary",
          elevation: 0,
          variant: "flat"
        },
        class: "px-4",
      },
      VSelect: {
        VChip: {
          class: "text-primary"
        }
      }
    },
    VDialog: {
      VCard: {
        VCardTitle: {
          class: "my-2"
        },
        VCardActions: {
          class: "my-2 px-3",
        },
      }
    },
    VCol: {
      class: "py-1"
    },
    VBtn: {
      style: {
        textTransform: "none",
      },
    },
    VTextField: {
      counter: 255,
      rules: [
        (value: string) => (String(value) ? String(value).length : 0) <= 255 || 'Max 255 characters'
      ]
    },
  },
  date: {
    formats: {
      date: "MM/DD/YYYY",
      datetime: "MM/DD/YYYY HH:mm",
      time: "HH:mm",
    },
  },
  icons: {
    defaultSet: "mdi",
  }
})
